// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1379R","option":"styles_option__3DoEr","selected":"styles_selected__2S7Q8"};